export default __webpack_public_path__ + "static/sales-end-date-track-af8d94ca6d074ec7ac265ccbaee7698a.mp4";